/**
 * SocialProof — an honest trust band. Rather than fabricated testimonials or
 * borrowed logos, it states verifiable capability facts (supported networks,
 * always-on AI team, all-in-one scope, Canadian compliance) alongside the core
 * value points. Everything here is a real product claim.
 */

import { PROOF_SECTION, PROOF_STATS } from '@/routes/landing/landing-data';
import { Icon } from './shared';

export function SocialProof() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8 lg:py-24">
      <div className="overflow-hidden rounded-token-xl border border-border bg-surface shadow-elevation-2">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          {/* Value points */}
          <div className="p-8 sm:p-10 lg:p-12">
            <p className="text-sm font-semibold uppercase tracking-widest text-primary">{PROOF_SECTION.eyebrow}</p>
            <h2 className="mt-3 text-balance text-2xl font-bold tracking-tight text-foreground sm:text-3xl">
              {PROOF_SECTION.title}
            </h2>
            <ul className="mt-6 space-y-4">
              {PROOF_SECTION.points.map((point) => (
                <li key={point} className="flex items-start gap-3">
                  <span className="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-500/15 text-emerald-600 dark:text-emerald-400">
                    <Icon name="check" className="h-4 w-4" strokeWidth={2.4} />
                  </span>
                  <span className="text-pretty leading-relaxed text-foreground">{point}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Stat grid on a brand gradient */}
          <div className="relative isolate overflow-hidden bg-gradient-to-br from-indigo-600 via-violet-600 to-fuchsia-600 p-8 sm:p-10 lg:p-12">
            <div aria-hidden="true" className="absolute inset-0 -z-10 bg-[radial-gradient(120%_120%_at_15%_0%,rgb(255_255_255/0.18),transparent_55%)]" />
            <div className="grid grid-cols-2 gap-6">
              {PROOF_STATS.map((stat) => (
                <div key={stat.label}>
                  <p className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl">{stat.value}</p>
                  <p className="mt-1 text-sm leading-snug text-white/85">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
